import React from 'react';
import { LocaleLabel } from './styles';
import { LocaleFlag } from './LocaleFlag';
import { Text } from '../TypographyPublicSite';
import { useLocale } from '../../../utils/locale';

const LocaleMenuLabel = ({ locale, onClick, padding, bold }) => {
  const { locale: selectedLocale } = useLocale();
  const { label, language } = locale;
  const isSelected = selectedLocale.code === locale.code;

  return (
    <LocaleLabel onClick={onClick} onKeyDown={onClick} $padding={padding}>
      <LocaleFlag locale={locale} />
      <Text bold={isSelected || bold} lang={language}>
        {label}
      </Text>
    </LocaleLabel>
  );
};

export default LocaleMenuLabel;
